import { render, staticRenderFns } from "./NavBarHorizontalLayout.vue?vue&type=template&id=36a9ae53&scoped=true"
import script from "./NavBarHorizontalLayout.vue?vue&type=script&lang=js"
export * from "./NavBarHorizontalLayout.vue?vue&type=script&lang=js"
import style0 from "./NavBarHorizontalLayout.vue?vue&type=style&index=0&id=36a9ae53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a9ae53",
  null
  
)

export default component.exports